import { render, staticRenderFns } from "./SeventhPage.vue?vue&type=template&id=0a1209f1&scoped=true"
import script from "./SeventhPage.vue?vue&type=script&lang=js"
export * from "./SeventhPage.vue?vue&type=script&lang=js"
import style0 from "./SeventhPage.vue?vue&type=style&index=0&id=0a1209f1&prod&lang=scss&scoped=true"
import style1 from "./SeventhPage.vue?vue&type=style&index=1&id=0a1209f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1209f1",
  null
  
)

export default component.exports